<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      {{ agenda.AgendaName }}
    </h5>
    <div>
      <div class="row">
        <div
          class="col-12"
        >
          <div class="font-weight-bold h6">
            {{ formatDate(agenda.StartDate) }}
          </div>
          <div class="text-right font-italic">
            {{ formatStartTime(agenda.StartDate) }} at {{ agenda.Location }}
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="font-weight-bold">
      Assigned Agenda Items
    </div>
    <div v-if="presentationNames.length > 0">
      <div
        v-for="p in presentationNames"
        :key="p"
      >
        {{ p }}
      </div>
    </div>
    <div
      v-else
      class="p-2"
    >
      You have no assigned agenda items for this meeting
    </div>
  </card>
</template>

<script>
import agendaapi from '@/services/api/agenda'
import formatter from '@/services/formatter.js'

export default {
  name: 'HomeStaffNextMeeting',
  props: {
    errormsg: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      agenda: {},
      presentationNames: []
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init: function () {
      agendaapi.getNextAssignments(this.$root.courseKey, this.$root.scouterKey)
        .then(x => {
          this.agenda = x.Agenda
          this.presentationNames = x.PresentationNames
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatDate: function (dt) {
      return formatter.formatAsShortDate(dt)
    },
    formatStartTime: function (dt) {
      return formatter.formatAsTime(dt)
    }
  }
}
</script>
